class Kernel {
    private readonly factories: { [key: string]: object } = {};

    constructor() {
        this.factories = {};
    }

    registerComponent(uname: string, Factory: any) {
        let wrapper = Factory;

        if (Kernel.isNativeClass(Factory)) {
            wrapper = function (html: HTMLElement) {
                return new Factory(html);
            };
        }
        Object.assign(this.factories, { [uname]: wrapper });
        return this;
    }

    createComponent(element: HTMLElement) {
        const uname = element.getAttribute('data-mount');

        if (!uname) return null;

        const factory = this.factories[uname] as any;
        if (!factory) {
            console.log(`${uname} component not found`);
            return null;
        }

        return factory(element);
    }

    mountComponents(view: HTMLElement) {
        const self = this;

        view.querySelectorAll('[data-mount]').forEach((element: HTMLElement) => {
            if (element.hasAttribute('component')) {
                return null;
            }
            const component = self.createComponent(element);
            (window as any).dataStorage.put(element, 'component', component);
            return null;
        });
    }

    static getComponent(componentId: string) {
        const node = document.getElementById(componentId) as HTMLElement;
        if (node) return (window as any).dataStorage.get(node, 'component');
        return null;
    }

    private static isNativeClass(thing: any) {
        return typeof thing === 'function' && Object.getPrototypeOf(thing) !== Object.prototype; // && !thing.hasOwnProperty('arguments');
    }
}

export default new Kernel();
